import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ViewAlertComponent } from '../main/alert/view-alert/view-alert.component';
import { ViewAlertHistoryComponent } from '../main/alert-history/view-alert-history/view-alert-history.component';

const routes: Routes = [
    {path: 'activeAlerts/view-alert/:id', component: ViewAlertComponent, pathMatch: 'full'},
    {path: 'alertHistory/view-alert-history/:alertId', component: ViewAlertHistoryComponent, pathMatch: 'full'}
]


@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
  })
  export class GenericComponentsRoutingModule { }